"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _ButtonModule = _interopRequireDefault(require("./Button.module.scss"));

var _excluded = ["children", "as", "isActive", "isLoading", "variant", "accent", "fluid", "border", "disabled", "className", "forwardedRef", "classes", "icon"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = function Button(_ref) {
  var _cx;

  var children = _ref.children,
      BaseButton = _ref.as,
      isActive = _ref.isActive,
      isLoading = _ref.isLoading,
      variant = _ref.variant,
      accent = _ref.accent,
      fluid = _ref.fluid,
      border = _ref.border,
      disabled = _ref.disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      forwardedRef = _ref.forwardedRef,
      classes = _ref.classes,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  var variantClass = _ButtonModule["default"][variant] || '';
  return /*#__PURE__*/_react["default"].createElement(BaseButton, _extends({
    className: (0, _classnames["default"])((_cx = {}, _defineProperty(_cx, "".concat(className, " ").concat(_ButtonModule["default"].button), true), _defineProperty(_cx, variantClass, !!variantClass), _defineProperty(_cx, _ButtonModule["default"][accent], accent), _defineProperty(_cx, "".concat(_ButtonModule["default"].active, " ").concat(classes.active), isActive), _defineProperty(_cx, _ButtonModule["default"].bordered, border), _defineProperty(_cx, _ButtonModule["default"].fluid, fluid), _defineProperty(_cx, "".concat(_ButtonModule["default"].disabled, " ").concat(classes.disabled), disabled), _defineProperty(_cx, _ButtonModule["default"].loading, isLoading), _defineProperty(_cx, _ButtonModule["default"].withIcon, !!icon), _cx)),
    ref: forwardedRef
  }, props), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: icon,
    className: (0, _classnames["default"])(_ButtonModule["default"].icon, classes.btnIcon)
  }), children, isLoading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    className: _ButtonModule["default"].loader
  }));
};

process.env.NODE_ENV !== "production" ? Button.propTypes = {
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].elementType]),
  fluid: _propTypes["default"].bool,
  isActive: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  border: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['flat', 'ghost', 'fill']),
  accent: _propTypes["default"].oneOf(['grey', 'positive', 'negative', 'purple', 'orange', 'blue', 'cyan', 'sheets']),
  className: _propTypes["default"].string,
  children: _propTypes["default"].any.isRequired
} : void 0;
Button.defaultProps = {
  as: 'button',
  fluid: false,
  border: false,
  isActive: false,
  isLoading: false,
  variant: undefined,
  accent: undefined,
  className: '',
  classes: {
    active: '',
    disabled: ''
  }
};
var _default = Button;
exports["default"] = _default;